// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartActionsStyles } from "@conklin/Overrides/Widgets/Cart/CartActions";
import IconAddProject from "@conklin/XDL/Icons/IconAddProject";
import IconClose from "@conklin/XDL/Icons/IconClose";
import IconPrint from "@conklin/XDL/Icons/IconPrint";
import IconSave from "@conklin/XDL/Icons/IconSave";
import { iconButtonCommonStyles, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

const clickableStyles = css`
    ${xScreen("lte", "md")} {
        width: 50%;
    }
`;

cartActionsStyles.wrapper = {
    css: css`
        display: flex;
        gap: 16px 24px;
        align-items: center;
        ${xScreen("lte", "md")} {
            flex-wrap: wrap;
            gap: 16px 0;
            & > :nth-child(odd) {
                justify-content: flex-start;
            }
            & > :nth-child(even) {
                justify-content: flex-end;
            }
        }
    `,
};

cartActionsStyles.printClickable = {
    ...mergeWithCss(iconButtonCommonStyles(IconPrint, 12), {
        css: clickableStyles,
    }),
};

cartActionsStyles.saveOrderClickable = {
    ...mergeWithCss(iconButtonCommonStyles(IconSave), {
        css: clickableStyles,
    }),
};

cartActionsStyles.addAllToListClickable = {
    ...mergeWithCss(iconButtonCommonStyles(IconAddProject, 12), {
        css: clickableStyles,
    }),
};

cartActionsStyles.removeAllClickable = {
    ...mergeWithCss(iconButtonCommonStyles(IconClose, 9), {
        css: css`
            margin-left: auto;
            svg {
                overflow: unset;
            }
        `,
    }),
};
